import { render, staticRenderFns } from "./ThemedEntityForm.vue?vue&type=template&id=131f2eb6&scoped=true"
import script from "./ThemedEntityForm.vue?vue&type=script&lang=js"
export * from "./ThemedEntityForm.vue?vue&type=script&lang=js"
import style0 from "./ThemedEntityForm.vue?vue&type=style&index=0&id=131f2eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f2eb6",
  null
  
)

export default component.exports